import { useQuery } from '@apollo/client/react';
import { useRouter } from 'next/router';

import { GetNotificationsDocument } from '@pflegia/data-access/queries.generated';
import { useAuth } from '@pflegia/ui/contexts/auth.context';
import { MAINTENANCE } from '@pflegia/ui/pflegia/constants/routes';

import { useSubscribeToNotifications } from './use-subscribe-to-notifications';

/**
 * Returns whether there are unread applications, offers, messages.
 */
export const useGetNotifications = () => {
  const authenticated = useAuth();
  const router = useRouter();
  const { data: queryData } = useQuery(GetNotificationsDocument, {
    fetchPolicy: 'network-only',
    skip: !authenticated || router.pathname === MAINTENANCE,
  });
  useSubscribeToNotifications();

  const hasApplicationNotification = Boolean(queryData?.applications?.count);
  const hasOfferNotification = Boolean(queryData?.offers?.count);
  const hasChatNotification = Boolean(queryData?.messages?.count);

  return { hasApplicationNotification, hasOfferNotification, hasChatNotification };
};
